export default {
  SET_VARIATION(state, payload) {
    state.variation = payload;
  },
};
